module.exports = __webpack_public_path__ + "static/media/LogicWheel1_4_1.947534ed.png";